/**
 * Lista de horas en formato 24h. Selección inmediata al hacer clic.
 * La hora actual se muestra en el encabezado del picker y no se repite aquí.
 *
 * @param {object} props
 * @param {string[]} props.slots
 * @param {string} props.value
 * @param {(slot: string) => void} props.onSelect
 */
export const DayTimeSlotList = ({ slots, value, onSelect }) => {
    const availableSlots = slots.filter((slot) => slot !== value);

    return (
        <div
            className="time-picker__day-list"
            role="listbox"
            aria-label="Horas disponibles"
        >
            {availableSlots.map((slot) => (
                <button
                    key={slot}
                    type="button"
                    role="option"
                    aria-selected={false}
                    className="time-picker__day-list-item"
                    onClick={() => onSelect(slot)}
                >
                    {slot}
                </button>
            ))}
        </div>
    );
};
